import { CLink } from "@coreui/react";
import React from "react";
import { PropTypes } from "prop-types";

const DocsLink = (props) => {
  const { name, text, ...rest } = props;

  const href = name
    ? `https://coreui.io/react/docs/components/${name}`
    : props.href;

  return (
    <div className="card-header-actions">
      <CLink
        {...rest}
        href={href}
        rel="noreferrer noopener"
        target="_blank"
        className="card-header-action"
      >
        <small className="text-muted">{text || "docs"}</small>
      </CLink>
    </div>
  );
};

DocsLink.propTypes = {
  name: PropTypes.string,
  text: PropTypes.string,
  href: PropTypes.string,
};

export default React.memo(DocsLink);
